import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Image, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import countryService from '../../services/countryService';
import exhibitionService from '../../services/exhibitionService';
import config from '../../config';

const ExhibitionPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [countries, setCountries] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [exhibitions, setExhibitions] = useState([]);

  useEffect(() => {
    loadCountries();
  }, []);

  useEffect(() => {
    if (selectedCountry) {
      loadExhibitions(selectedCountry.id);
    }
  }, [selectedCountry]);

  const loadCountries = async () => {
    try {
      const data = await countryService.getCountries();
      console.log('Countries data:', data);
      console.log('Data type:', typeof data);
      console.log('Is array:', Array.isArray(data));
      
      // Eğer data bir dizi değilse, boş dizi kullan
      if (Array.isArray(data)) {
        setCountries(data);
        // Debug: Görsel URL'lerini kontrol et
        data.forEach(country => {
          console.log(`Country: ${country.name}, Cover Image: ${country.cover_image}`);
          console.log(`Full URL: ${config.API_URL}${country.cover_image}`);
        });
      } else {
        console.error('Countries data is not an array:', data);
        setCountries([]);
      }
    } catch (error) {
      console.error('Failed to load countries:', error);
      setCountries([]);
    }
  };

  const loadExhibitions = async (countryId) => {
    console.log('Loading exhibitions for country:', countryId);
    try {
      const data = await exhibitionService.getExhibitionsByCountry(countryId);
      console.log('Loaded exhibitions:', data);
      console.log('Data type:', typeof data);
      console.log('Is array:', Array.isArray(data));
      setExhibitions(data); // Backend'den gelen direkt array'i kullanıyoruz
      
      // Debug: Exhibition görsel URL'lerini kontrol et
      if (Array.isArray(data)) {
        data.forEach(exhibition => {
          console.log(`Exhibition: ${exhibition.title}, Image URL: ${exhibition.image_url}`);
          console.log(`Full URL: ${config.API_URL}${exhibition.image_url}`);
        });
      }
    } catch (error) {
      console.error('Failed to load exhibitions:', error);
    }
  };

  const handleExhibitionClick = (exhibitionId) => {
    console.log('Exhibition clicked with ID:', exhibitionId);
    console.log('Navigating to:', `/exhibition/${exhibitionId}`);
    navigate(`/exhibition/${exhibitionId}`);
  };

  return (
    <div className="exhibition-page">
      <Container className="py-5 mt-5">
        {!selectedCountry ? (
          <>
            <h2 className="text-left mb-4">{t('exhibitions.title')}</h2>

            <Row xs={1} md={3} className="g-4">
              {Array.isArray(countries) && countries.length > 0 ? (
                countries.map(country => (
                  <Col key={country.id}>
                    <Card 
                      className="h-100 country-card" 
                      onClick={() => setSelectedCountry(country)}
                    >
                      <Card.Img 
                        variant="top" 
                        src={`${config.API_URL}${country.cover_image}`}
                        style={{ height: '200px', objectFit: 'cover' }}
                      />
                      <Card.Body>
                        <Card.Title className="text-center">{country.name}</Card.Title>
                      </Card.Body>
                    </Card>
                  </Col>
                ))
              ) : (
                <Col xs={12}>
                  <div className="text-center py-5">
                    <p className="text-muted">No countries available</p>
                  </div>
                </Col>
              )}
            </Row>
          </>
        ) : (
          <>
            <div className="d-flex align-items-center mb-4">
              <button 
                className="btn btn-link p-0 me-3"
                onClick={() => setSelectedCountry(null)}
              >
                ← {t('common.back')}
              </button>
              <h2 className="mb-0">{selectedCountry.name} {t('exhibitions.title')}</h2>
            </div>
            

            
            <Row xs={1} md={2} lg={3} className="g-4">
              {Array.isArray(exhibitions) && exhibitions.length > 0 ? (
                exhibitions.map((exhibition) => (
                  <Col key={exhibition.id}>
                    <Card 
                      className="exhibition-card h-100" 
                      onClick={() => handleExhibitionClick(exhibition.id)}
                      style={{ cursor: 'pointer' }}
                    >
                      <Card.Img 
                        variant="top" 
                        src={`${config.API_URL.replace('/api', '')}${exhibition.image_url}`}
                        style={{ 
                          height: '300px', 
                          objectFit: 'cover',
                          width: '100%'
                        }}
                      />
                      <Card.Body>
                        <Card.Title>{exhibition.title}</Card.Title>
                        <Card.Text className="text-muted">
                          {exhibition.description}
                        </Card.Text>
                      </Card.Body>
                    </Card>
                  </Col>
                ))
              ) : (
                <Col xs={12}>
                  <div className="text-center py-5">
                    <p className="text-muted">
                      {Array.isArray(exhibitions) 
                        ? `No exhibitions available for ${selectedCountry.name}` 
                        : 'Loading exhibitions...'
                      }
                    </p>
                  </div>
                </Col>
              )}
            </Row>
          </>
        )}
      </Container>
    </div>
  ); // Tek return statement
}; // Component sonu

export default ExhibitionPage;